
import goart_logo from 'assets/goart/goart_logo.png';
import {
    goartDownloadApp
} from "~/utils/common";
import { mapMutations, mapState } from 'vuex'

export default {
    data () {
        return {
            goart_logo,
            pageData: this.$t("goart_header_bar"),
        }
    }, 
    mounted(){
        let GoArtHeadBarHeight = this.$refs.head_bar.getBoundingClientRect().height;
        this.setMobileState({ key: "GoArtHeadBarHeight", value: GoArtHeadBarHeight });
    },
    methods: {
        ...mapMutations({
            setMobileState: 'mobile/setMobileState'
        }),
        //
        btnClick () {
            goartDownloadApp();
        }
    }
}
